import React from 'react';

interface ImageDisplayProps {
  imagePath?: string;
  alt?: string;
  className?: string;
  showPlaceholder?: boolean;
  onClick?: () => void;
}

const ImageDisplay: React.FC<ImageDisplayProps> = ({
  imagePath,
  alt = '图片',
  className = '',
  showPlaceholder = true,
  onClick
}) => {
  if (!imagePath) {
    if (!showPlaceholder) return null;
    
    return (
      <div 
        className={`flex items-center justify-center w-full h-48 bg-gray-100 border-2 border-dashed border-gray-300 rounded-lg ${className}`}
        onClick={onClick}
      >
        <div className="text-center">
          <svg 
            className="mx-auto h-12 w-12 text-gray-400" 
            fill="none" 
            viewBox="0 0 24 24" 
            stroke="currentColor"
          >
            <path 
              strokeLinecap="round" 
              strokeLinejoin="round" 
              strokeWidth={2} 
              d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" 
            />
          </svg>
          <p className="mt-2 text-sm text-gray-500">暂无图片</p>
        </div>
      </div>
    );
  }

  // 处理相对路径和绝对路径
  const imageUrl = imagePath.startsWith('http') || imagePath.startsWith('data:')
    ? imagePath 
    : `${window.location.origin}/storage/${imagePath}`;

  return (
    <div className={`relative group ${className}`}>
      <div className="relative overflow-hidden rounded-lg border border-gray-200 shadow-sm hover:shadow-lg transition-all duration-300">
        <img
          src={imageUrl}
          alt={alt}
          className="w-full h-auto max-h-64 object-cover transform transition-all duration-300 group-hover:scale-105 cursor-pointer"
          onClick={onClick}
          onError={(e) => {
            // 图片加载失败时显示占位符
            const target = e.target as HTMLImageElement;
            target.style.display = 'none';
            if (target.nextSibling) {
              (target.nextSibling as HTMLElement).style.display = 'flex';
            }
          }}
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none"></div>
        
        {/* 图片加载失败的占位符 */}
        <div 
          className="hidden items-center justify-center w-full h-48 bg-gray-100 border-2 border-dashed border-gray-300 rounded-lg absolute inset-0"
          onClick={onClick}
        >
          <div className="text-center">
            <svg 
              className="mx-auto h-12 w-12 text-gray-400" 
              fill="none" 
              viewBox="0 0 24 24" 
              stroke="currentColor"
            >
              <path 
                strokeLinecap="round" 
                strokeLinejoin="round" 
                strokeWidth={2} 
                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 15.5c-.77.833.192 2.5 1.732 2.5z" 
              />
            </svg>
            <p className="mt-2 text-sm text-gray-500">图片加载失败</p>
          </div>
        </div>
        
        {/* 悬停时显示的放大镜图标 */}
        {onClick && (
          <div className="absolute top-2 right-2 bg-black bg-opacity-50 text-white p-2 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-200">
            <svg 
              className="w-4 h-4" 
              fill="none" 
              viewBox="0 0 24 24" 
              stroke="currentColor"
            >
              <path 
                strokeLinecap="round" 
                strokeLinejoin="round" 
                strokeWidth={2} 
                d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0zM10 7v3m0 0v3m0-3h3m-3 0H7" 
              />
            </svg>
          </div>
        )}
      </div>
    </div>
  );
};

export default ImageDisplay;